import { LinkButton, SectionTitle } from '@sleepstation/components'
import { CopyParagraph } from '@sleepstation/components-copy'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_SPACING, SIZE } from '@sleepstation/const'
import {
  marginBottom,
  marginTop,
  marginV,
  mq,
} from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import { always, assoc, ifElse } from 'ramda'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import BreakoutModuleNarrower from '../../../shared/breakoutModules/BreakoutModuleNarrower'
import InfoCards from '../../../shared/InfoCards'
import infoTheme from '../../../../themes/infoTheme'
import InfoPill from '../../../shared/InfoPill'
import Video from '../../../shared/Video'
import BenefitsCard from '../../../shared/BenefitsCard'
import TestimonialSection from '../../../shared/TestimonialSection'

const modifyCtaButtonBasedOnUserState = ({ canEnrolmentAccessProgramme }) =>
  ifElse(
    always(canEnrolmentAccessProgramme),
    (o) => assoc(`label`, o.labelHasStarted, o),
    (o) => assoc(`label`, o.labelHasNotStarted, o)
  )
// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const InfoPillWrapper = styled(VLayout).attrs({ align: LAYOUT_ALIGN.CENTER })`
  ${mq(`mediumUp`)} {
    ${marginTop([1.75])}
  }
`

const InfoPillSubsectionCopy = styled(CopyParagraph)`
  ${marginTop(0.33)}
`

const SubsectionCopy = styled(CopyParagraph)`
  ${marginTop(0.33)}
`

const ButtonCtaWrapper = styled(VLayout).attrs({ align: LAYOUT_ALIGN.CENTER })`
  ${marginV([1.5, 1.5, 2])}
  > * {
    width: 100%;
    ${mq(`smallUp`)} {
      max-width: 346px;
    }
  }
`

const SecondaryButtonCtaWrapper = styled(VLayout).attrs({
  align: LAYOUT_ALIGN.CENTER,
})`
  ${marginTop(1)}
  ${marginBottom(2)}
  > * {
    width: 100%;
    ${mq(`smallUp`)} {
      max-width: 346px;
    }
  }
`

const VideoWrapper = styled.div`
  ${marginTop([1, 1, 1.75])}
  ${marginBottom(1)}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const HubBuyTherapyGrantPage = ({ canEnrolmentAccessProgramme, content }) => {
  const ctaButton = modifyCtaButtonBasedOnUserState({
    canEnrolmentAccessProgramme,
  })(content.ctaButton)

  const ctaButtonSecondary = modifyCtaButtonBasedOnUserState({
    canEnrolmentAccessProgramme,
  })(content.ctaButtonSecondary)

  return (
    <BreakoutModuleNarrower
      hasBottomBorder={false}
      hasGradient={false}
      marginV={[
        [1.5, 2],
        [1.5, 3],
        [2.5, 4],
      ]}
    >
      <VLayout spacing={[LAYOUT_SPACING.LARGE]} align={LAYOUT_ALIGN.STRETCH}>
        <SectionTitle align="center">{content.title}</SectionTitle>
        <BenefitsCard
          image={content.benefitsCard.image}
          primary={content.benefitsCard.primary}
        />
        <InfoPillWrapper>
          <ThemeProvider theme={infoTheme}>
            <InfoPill {...content.infoPill} />
            <InfoPillSubsectionCopy>
              {content.infoPill.description}
            </InfoPillSubsectionCopy>
          </ThemeProvider>
        </InfoPillWrapper>
        <VideoWrapper>
          <Video {...content.video} />
        </VideoWrapper>
        <SubsectionCopy>{content.subsectionCopy}</SubsectionCopy>
        <InfoCards {...content.infoCards} />
        <ButtonCtaWrapper>
          <LinkButton
            data-cy={`buy-therapy-grant-primary-cta`}
            href={ctaButton.url}
            size={SIZE.SMALL}
          >
            {ctaButton.label}
          </LinkButton>
        </ButtonCtaWrapper>
        <TestimonialSection {...content.patientShortStories} />
        <SecondaryButtonCtaWrapper>
          <LinkButton href={ctaButtonSecondary.url} size={SIZE.SMALL}>
            {ctaButtonSecondary.label}
          </LinkButton>
        </SecondaryButtonCtaWrapper>
      </VLayout>
    </BreakoutModuleNarrower>
  )
}

HubBuyTherapyGrantPage.propTypes = {
  content: PropTypes.object.isRequired,
  canEnrolmentAccessProgramme: PropTypes.bool.isRequired,
}

export default HubBuyTherapyGrantPage
